import { motion } from 'framer-motion';
import type { Machine } from '@/pages/Maschinenpark';

interface MachineCardProps {
  machine: Machine;
  index: number;
}

export function MachineCard({ machine, index }: MachineCardProps) {
  return (
    <motion.div
      className="card-industrial overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={machine.image}
          alt={machine.name}
          className="w-full h-full object-cover image-protected"
          draggable={false}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-card via-transparent to-transparent" />
        {machine.quantity > 1 && (
          <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-primary/90 text-primary-foreground text-sm font-mono">
            {machine.quantity}×
          </div>
        )}
      </div>

      <div className="p-6">
        <h3 className="text-xl font-bold">{machine.name}</h3>
        <p className="mt-2 text-sm text-muted-foreground">{machine.description}</p>

        <div className="mt-4 space-y-2 technical-data">
          {machine.specs.map((spec) => (
            <div
              key={spec.label}
              className="flex justify-between items-center py-2 border-b border-border/30 last:border-0"
            >
              <span className="text-sm text-muted-foreground">{spec.label}</span>
              <span className="text-sm font-mono font-medium text-primary">{spec.value}</span>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
